<div class="mb-5">
  <div class="col-sm-12 pl-0 pr-0">
    <!--If there are any results-->
    @if (dataListArray?.length > 0 && !isListLoading) {
    <el-data-list-table
      [data]="dataListArray"
      [totalCount]="totalCount"
      [pageSize]="pageSize"
      [showMoreButtonEnabled]="showMoreButtonEnabled"
      [downloadButtonEnabled]="downloadButtonEnabled"
      [getAllButtonEnabled]="getAllButtonEnabled"
      (onChangePageSize)="onChangePageSize.emit($event)"
      (onClickShowMore)="onClickShowMore.emit($event)"
      (onClickAction)="onClickAction.emit($event)"
      (onElementExpand)="onElementExpand.emit($event)"
      (onDataElementClickAction)="onDataElementClickAction.emit($event)"
      (onClickGetAll)="onClickGetAll.emit($event)"
      (onExpandableElementExpand)="onExpandableElementExpand.emit($event)"
      (expandableElementActionButtonClicked)="
        expandableElementActionButtonClicked.emit($event)
      "
    >
    </el-data-list-table>
    } @else { @if (!isListLoading) {
    <app-no-results-found></app-no-results-found>
    } }

    <!--If there are no results-->

    @if (isListLoading) {
    <app-skeleton-data-list-table
      style="width: 100%"
    ></app-skeleton-data-list-table>
    }
  </div>
</div>

<app-action-button
  [buttons]="filteredActionButtons"
  (clickAction)="onClickActionButton.emit($event)"
></app-action-button>
